/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import accusationIcon from "../../assets/icons/progress/icon_progressbar_document.svg";
import carIcon from "../../assets/icons/progress/icon_progressbar_car.svg";
import personalIcon from "../../assets/icons/progress/icon_progressbar_personoftrust.svg";

const progressBarsteps = [
  {
    key: "accusation",
    name: "Verstoß",
    icon: accusationIcon,
  },
  {
    key: "driver",
    name: "Zum Fahrer",
    icon: carIcon,
  },
  {
    key: "personal",
    name: "Persönliche Angaben",
    icon: personalIcon,
  },
];

export default progressBarsteps;
